import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { jwtDecode } from 'jwt-decode';
import { getHostname } from '../../../utils/getHostname';
import { getCookie } from '../../../auth/handleCookie';
import navItems from '../../../utils/navItems';
import { Tooltip } from '@mui/material';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import { useGetSessionQuery } from '../../../api/apiSlice';
import { useSelector } from 'react-redux';
import { getSelectedAccount } from '../../../redux/selectedAccountSlice';

export default function HomePage() {
  // const token = getCookie(`${getHostname()}_auth`)
  // const tokenDecoded = jwtDecode(token)
  const { data: sessionData } = useGetSessionQuery();
  const selectedAccount = useSelector(getSelectedAccount)

  const { t } = useTranslation('glossary');

  const isAdmin = sessionData?.claims?.['accounts.superuser'] === "True" || false;

  const filteredItems = isAdmin
    ? navItems
    : navItems.filter((item) =>
        !item.isAdmin
      );
  

  const navigate = useNavigate();
  const hasService = (service) => {
    if (service === undefined) return true
    if (selectedAccount.Services?.some(s => s.Name === service)) return true
    return false
  }


  return (
    <Fade in={true} timeout={500}>
    <Box
      id="highlights"
      sx={{
        pt: { xs: 4, sm: 4 },
        pb: { xs: 8, sm: 4 },
        bgcolor: (theme) => theme.palette.mode === 'light'
        ? '#FCFCFC'
        : theme.palette.grey[900],
      }}
    >
      <Container
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: { xs: 3, sm: 6 },
        }}
      >
        <Box
          sx={{
            width: { sm: '100%', md: '60%' },
            textAlign: { sm: 'left', md: 'center' },
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', mb: 2 }}>
            <Typography 
            variant="h4" 
            className="Re" 
            sx={{ 
              fontFamily: 'neuropolitical',
              color: (theme) => theme.palette.mode === 'light' ? 'hsl(0, 0%, 20%)' : 'hsl(0, 0%, 85%)', 
              fontWeight: 'bold' 
            }}
          >
            Re
          </Typography>
          <Typography 
            variant="h4" 
            className="M" 
            sx={{ 
              fontFamily: 'neuropolitical',
              color: 'hsl(63, 100%, 40%)', 
              fontWeight: 'bold' 
            }}
          >
            M
          </Typography> 
          <Typography 
            variant="h4" 
            className="oni" 
            sx={{ 
              fontFamily: 'neuropolitical',
              color: (theme) => theme.palette.mode === 'light' ? 'hsl(0, 0%, 20%)' : 'hsl(0, 0%, 85%)', 
              fontWeight: 'bold' 
            }}
          >
            oni
          </Typography>
          </Box>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          { t('glossary:landing-page-text')}
          </Typography>
        </Box>
        <Grid container spacing={2.5}>
          {filteredItems?.map((item, index) => 
          {
          if (item.title === "monitor") return null
          if (!hasService(item.service) && !isAdmin) return null
          return (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Stack
                direction="column"
                color="inherit"
                component={Card}
                spacing={1}
                // variant='outlined'
                elevation={0}
                onClick={() => navigate(`/${item.title}`)}
                useFlexGap
                sx={{
                  p: 3,
                  // boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%)",
                  border: '1px solid',
                  borderColor: 'divider',
                  transition: 'box-shadow 0.3s ease',
                  ':hover': {
                    // borderColor: (theme) => theme.palette.mode === 'light' ? 'hsl(0, 0%, 80%)' : 'hsl(0, 0%, 30%)',
                    boxShadow: "0 20px 27px 0 rgb(0 0 0 / 5%)",
                    cursor: 'pointer',
                    elevation: 2,
                  },
                  height: '100%',
                  backgroundColor: (theme) => theme.palette.mode === 'light' ? '#FCFCFC' : '#121212',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                  }}
                >
                <Box>{item.icon}</Box>
                  <Box>
                    
                    {item.isAdmin ? <Tooltip title="Admin feature"><AdminPanelSettingsRoundedIcon fontSize='small' /></Tooltip> : null}
                    {item.state}
                  </Box>
                </Box>
                <div>
                  <Typography fontWeight="medium" gutterBottom>
                    {t(`glossary:${item.title}`)}
                  </Typography>
                  <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                    {t(`glossary:landing-page-${item.title}`)}
                  </Typography>
                </div>
              </Stack>
            </Grid>
          )})}
        </Grid>
      </Container>
    </Box>
    </Fade>
  );
}